import { BrandLoader, styles } from "./BrandLoader";
import { withStyles } from "@material-ui/core/styles";

export default withStyles(styles)(BrandLoader);
